<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
html {
  font-size: ($vw_fontsize / $vw_base) * 100vw;
  @media screen and (max-width: 1366px) {
    font-size: 13.66px;
  }
  @media screen and (min-width: 1920px) {
    font-size: 19.2px;
  }
  // font-family: SourceHanSansCN-Regular;

  // @include scroll-bar;
}
.el-select-dropdown__item.selected {
  color: #05579e !important;
}

// @font-face {
//   font-family: 'SourceHanSansCN-Regular';
//   src: url('./assets/font/DroidSansChinese.ttf');
// }
</style>



// WEBPACK FOOTER //
// src/App.vue